import { axiosDefaultInstance } from '@/http/default'
import type { AxiosInstance } from 'axios'
import handleError from './util/ErrorHandler'
import type { ServiceError } from './util/ServiceError'
import type FeatureFlagsCompany from '@/model/FeatureFlagsCompany'

class FeatureFlagsService {
  private axiosInstance: AxiosInstance

  constructor() {
    this.axiosInstance = axiosDefaultInstance
  }

  async getFeatureFlags(companyId: string): Promise<FeatureFlagsCompany | ServiceError> {
    try {
      const networkResponse = await this.axiosInstance.get<FeatureFlagsCompany>(
        `${import.meta.env.VITE_API_BASE_URL}/company/${companyId}/feature-flags`
      )
      return networkResponse.data
    } catch (error) {
      return handleError(error)
    }
  }
}

export const featureFlagsService = new FeatureFlagsService()
